import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import EmailPanel from "./pages/EmailPanel";
import BlogPanel from "./pages/BlogPanel";
import BlogForm from "./components/BlogForm";
import NewsletterPanel from "./pages/NewsletterPanel";
import NewsletterForm from "./components/NewsletterForm";
import NewsletterList from "./components/NewsletterList";

function App() {

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/admin/login";
    };

    const isAuth = !!localStorage.getItem("token");

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Navigate to="/admin/login" />} />

            <Route index element={
                isAuth ? (
                    <AdminPanel onLogout={handleLogout} />
                ) : (
                    <Navigate to="/admin/login"/>
                )
            }/>

            <Route path="/emails" element={
                isAuth ? (
                    <EmailPanel/>
                ) : (
                    <Navigate to="/admin/login"/>
                )
            }/>

            <Route path="/blogs" element={
                isAuth ? (
                    <BlogPanel/>
                ) : (
                    <Navigate to="/admin/login"/>
                )
            }/>

            <Route path="/blogs/new" element={
                isAuth ? (
                    <BlogForm/>
                ) : (
                    <Navigate to="/admin/login"/>
                )
            }/>
            <Route path="/blogs/edit/:id" element={
                isAuth ? (
                    <BlogForm/>
                ) : (
                    <Navigate to="/admin/login"/>
                )
            }/>
            <Route path="/newsletter" element={ isAuth ? <NewsletterPanel/> : <Navigate to="/admin/login" /> } />
            <Route path="/newsletter/:year" element={ isAuth ? <NewsletterList/> : <Navigate to="/admin/login" /> } />
            <Route path="/newsletter/:year/:month" element={ isAuth ? <NewsletterForm/> : <Navigate to="/admin/login" /> } />
        </Routes>
    );
}

export default App;